import { Icon } from '@chakra-ui/react'
import styled from '@emotion/styled'

const IconSt = styled(Icon)``

export { IconSt }
